import axios from 'axios';

import { appConfig } from 'src/app';

import { AgreementsServiceTypes } from './types';

class AgreementsServiceClientImpl implements AgreementsServiceTypes {
    private baseUrl: string;

    constructor() {
        this.baseUrl = appConfig.pdfGeneratorUrl!;
    }

    public async getAgreement(
        parking: boolean,
        country: string,
        roomCode: string,
        isHouseOfSocial: boolean
    ): Promise<string> {
        try {
            const response = await axios.get(this.baseUrl, {
                params: {
                    parking,
                    country,
                    roomCode,
                    isHouseOfSocial,
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error);
        }
    }
}

export default AgreementsServiceClientImpl;
